import { Wire } from '@treasury/domain/wires/wire.entity';
import { TmBaseComponent } from '@treasury/presentation';
import '@treasury/presentation/components/tm-footer';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../../components/confirmation-container';
import './wire-data-readonly';

export const tagName = 'wire-confirm-step';
@customElement(tagName)
export class WireConfirmStep extends TmBaseComponent {
    @property({ type: Object })
    public wire: Wire = new Wire();

    @property({ type: String })
    public wireTemplateName = '';

    protected render() {
        return html`<confirmation-container .headingText=${'Wire Submitted'}>
                <wire-data-readonly
                    .wire=${this.wire}
                    .wireTemplateName=${this.wireTemplateName}
                    .creditorDetail=${false}
                ></wire-data-readonly>
            </confirmation-container>
            <tm-footer
                .buttonConfig=${[
                    {
                        text: 'Create another wire',
                        importance: 'secondary',
                        onClick: () => {
                            this.dispatchEvent(new CustomEvent('create-wire'));
                        },
                    },
                    {
                        text: 'View wire activity',
                        importance: 'secondary',
                        onClick: () => {
                            this.dispatchEvent(new CustomEvent('view-wires'));
                        },
                    },
                ]}
            ></tm-footer>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: WireConfirmStep;
    }
}
